import { render, staticRenderFns } from "./addProductType.vue?vue&type=template&id=6e12f10e"
import script from "./addProductType.vue?vue&type=script&lang=js"
export * from "./addProductType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports